import classNames from 'classnames';
import React from 'react';

import { calculateFileSize, MAX_TOTAL_FILE_SIZE_BYTES } from '../file-validation/file-validation';
import { Vedlegg, VedleggStatus } from '../filopplasting-types';

import './direct-filopplasting-indicator.scss';

interface Props {
    vedlegg: Vedlegg[];
}

const toMB = (n: number): number => {
    return Math.round((n / 1024 ** 2) * 10) / 10;
};

export const DirectFilopplastingIndicator = ({ vedlegg }: Props) => {
    const maxFileSize = toMB(MAX_TOTAL_FILE_SIZE_BYTES);
    const combinedFilesSize = toMB(
        calculateFileSize(
            vedlegg
                .filter((v) => v.status !== VedleggStatus.Error && v.status !== VedleggStatus.ErrorTotalFileSize)
                .map((v) => v.size),
        ),
    );
    const statusWidth = (combinedFilesSize / maxFileSize) * 100;
    return (
        <div className="direct-fil-upload-indicator">
            <div className="indicator-bar">
                <div
                    className={classNames('indicator-bar--status', { 'indicator-bar--status-max': statusWidth >= 100 })}
                    style={{ width: `${statusWidth}%` }}
                />
            </div>
            <div className="status-bar">
                <div>{`Totalt ${combinedFilesSize} MB`}</div>
                <div>{`${maxFileSize} MB`}</div>
            </div>
        </div>
    );
};
